import type { CurrentUser } from '@performance-crm/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef, useState, type ReactNode } from 'react';
import { getCurrentUser, onSessionChange, refreshSession } from './api';
import { AuthContext } from './auth-context';

export function AuthProvider({ children }: { children: ReactNode }) {
  const queryClient = useQueryClient();
  const [user, setUser] = useState<CurrentUser | null>(getCurrentUser());
  const [loading, setLoading] = useState(true);
  const lastUserId = useRef<string | null>(user?.id ?? null);

  useEffect(() => {
    // Las salas de venta comparten computadora: al cerrar sesión o entrar otro usuario se vacía la
    // memoria de consultas (Mi día, listas, catálogos) para que nadie vea los datos del anterior.
    const off = onSessionChange((next) => {
      const nextId = next?.id ?? null;
      if (nextId !== lastUserId.current) {
        lastUserId.current = nextId;
        queryClient.clear();
      }
      setUser(next);
    });
    refreshSession().finally(() => setLoading(false));
    return () => {
      off();
    };
  }, [queryClient]);

  return <AuthContext.Provider value={{ user, loading }}>{children}</AuthContext.Provider>;
}
